import { setupZodErrorMap } from '@shared/utils/zod-i18.util';

import { scan } from 'react-scan';
import './app/styles/index.css';
import './shared/config/i18n/i18n';

// MSW + auto-login + мок-конфиг должны быть полностью готовы до того, как роутер
// смонтируется и запустит свои loader'ы (см. serverLoader). Иначе первый роут-loader
// уходит в network до того как MSW успел перехватить запросы - получается CORS
// на реальный backend. Поэтому createRoot.render вызывается строго ВНУТРИ цепочки
// preparation, а импорт store/router отложен до завершения MSW init
async function preparation() {
  setupZodErrorMap();

  if (import.meta.env.VITE_APP_MODE === 'dev' && import.meta.env.VITE_APP_MOCK_API === 'true') {
    const { worker } = await import('./app/api/mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass', // Пробрасывать неописанные запросы
    });
    console.log('%cMock Service Worker запущен', 'color: green; font-weight: bold;');

    // Моковый автологин обходит Discord OAuth-popup для Playwright и ручной проверки.
    // Импорт store + endpoints здесь, чтобы не тянуть их в module-level до того как MSW готов
    if (import.meta.env.VITE_APP_MOCK_AUTO_LOGIN === 'true') {
      const { store } = await import('./app/store/instance/store');
      const { authAPI } = await import('./app/api/endpoints/auth');
      const { profileUserAPI } = await import('./app/api/endpoints/profile');
      try {
        await store.dispatch(authAPI.endpoints.login.initiate('mock-oauth-code')).unwrap();
        await store.dispatch(profileUserAPI.endpoints.getProfileUser.initiate()).unwrap();
        console.log('%cМоковый автологин: профиль загружен', 'color: green; font-weight: bold;');
      } catch (error) {
        console.warn('Моковый автологин не выполнен:', error);
      }
    }
  }
}

scan({
  enabled: import.meta.env.VITE_APP_MODE === 'dev',
  showFPS: true,
});

preparation().then(async () => {
  // Lazy-импорт всего, что зависит от store/router: до этого момента MSW гарантированно поднят
  const [
    { createRoot },
    { Provider },
    { HelmetProvider },
    { OAuthProvider, ThemeProvider, ToastProvider },
    { store },
    { CookieConsentProvider },
    { AppInitializer },
  ] = await Promise.all([
    import('react-dom/client'),
    import('react-redux'),
    import('react-helmet-async'),
    import('@app/providers'),
    import('./app/store/instance/store'),
    import('@features/Coockie'),
    import('./AppInitializer'),
  ]);

  // biome-ignore lint/style/noNonNullAssertion: root создаётся из обязательного DOM-узла index.html.
  createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
      <ThemeProvider>
        <ToastProvider>
          <OAuthProvider>
            <CookieConsentProvider>
              <HelmetProvider>
                <AppInitializer />
              </HelmetProvider>
            </CookieConsentProvider>
          </OAuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </Provider>,
  );
});
